/**
 * Mutates validation data returned from a query
 * into the full shape used in the Components
 */

import { type AddressFormInputValidation } from '@jouzen/ecom-components/v3/AddressForm';

import { AddressFormValidation } from '@/queries/types/graphql';

const transformValidationData = (
  validationData: Partial<AddressFormValidation> = {},
): AddressFormInputValidation => {
  const validation = Object.entries(validationData).reduce(
    (obj, [fieldName, fieldData]) => {
      if (!fieldData) {
        return obj;
      }

      const fieldConfig = Object.entries(fieldData).reduce(
        (config, [key, value]) => {
          return {
            ...config,
            [key]: { value },
          };
        },
        {},
      );

      return {
        ...obj,
        [fieldName]: fieldConfig,
      };
    },
    {} as AddressFormInputValidation,
  );

  return validation;
};

export default transformValidationData;
